import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';

function shouldUseCurrentOriginFirebaseAuthDomain(): boolean {
  const configuredValue = import.meta.env.VITE_FIREBASE_USE_CURRENT_ORIGIN_AUTH_DOMAIN;
  if (typeof configuredValue === 'string' && configuredValue.trim() !== '') {
    return configuredValue.toLowerCase() === 'true';
  }

  return import.meta.env.DEV;
}

function getFirebaseAuthDomain(): string {
  const configuredAuthDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN.trim() || '';

  if (
    shouldUseCurrentOriginFirebaseAuthDomain() &&
    typeof window !== 'undefined' &&
    window.location.host
  ) {
    return window.location.host;
  }

  return configuredAuthDomain;
}

// Lazy initialization: creating the Auth instance kicks off Firebase's
// persisted-session restore (network calls to identitytoolkit). Public pages
// (e.g. /external/...) must never trigger that, so nothing initializes at
// module import — only on the first getFirebaseApp()/getFirebaseAuth() call.
let app: FirebaseApp | undefined;
let auth: Auth | undefined;

export function getFirebaseApp(): FirebaseApp {
  app ??= initializeApp({
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: getFirebaseAuthDomain(),
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  });
  return app;
}

export function getFirebaseAuth(): Auth {
  auth ??= getAuth(getFirebaseApp());
  return auth;
}
